export const UI_TEXT = {
  ar: {
    dir: 'rtl',
    brandName: 'جسر المعرفة',
    tagline: 'مسابقة ثقافية بين متنافسين',
    teamAiName: 'لاعب ذكاء اصطناعي',
    loadingContent: 'تحميل المحتوى',
    chooseChallenge: 'اختر نوع التحدي',
    challengeTeams: 'تحدي فريقين',
    challengeTeamsSubtitle: 'فريقان على نفس الجهاز',
    challengeTeamsDesc: 'تناوبوا على اختيار المربعات والإجابة.',
    challengeAi: 'تحدي الذكاء الاصطناعي',
    challengeAiSubtitle: 'العب ضد خصم ذكي',
    challengeAiDesc: 'اختبر معلوماتك أمام منافس لا يختار عشوائياً.',
    challengeRemote: 'تحدي عن بعد',
    challengeRemoteSubtitle: 'كل فريق على جهازه',
    challengeRemoteDesc: 'العب مع أصدقائك أينما كانوا.',
    chooseChallengeAction: 'اختيار التحدي',
    gameSettings: '⚙️ إعدادات اللعبة',
    chooseQuestionType: 'اختر نوع الأسئلة',
    languageTitle: 'لغة الواجهة',
    languageDesc: 'التبديل بين العربية والإنجليزية',
    questionBanks: {
      'general-ar': {
        title: 'الأسئلة العامة — عربي',
        countText: '1200 سؤال',
        description: 'مناسبة للكبار والعائلة',
        languageLabel: 'عربي'
      },
      'general-en': {
        title: 'General — English',
        countText: '500 Questions',
        description: 'English questions for adults and families',
        languageLabel: 'English'
      },
      'kids-ar': {
        title: 'أطفال — عربي',
        countText: '300 سؤال',
        description: 'أسئلة ذكية وممتعة للأطفال من عمر 8 إلى 11 سنة',
        languageLabel: 'عربي'
      },
      'kids-en': {
        title: 'Kids — English',
        countText: '300 Questions',
        description: 'Smart and fun questions for kids ages 8 to 11',
        languageLabel: 'English'
      }
    },
    remoteTitle: 'تحدي عن بعد',
    remoteDesc: 'هذا التحدي سيكون متوفراً في نسخة الجوال فقط. تطبيق جسر المعرفة على الجوال لتلعب مع أصدقائك كل فريق على جهازه.',
    comingSoon: 'إنتظرونا قريباً',
    ok: 'حسناً',
    setupAiTitle: 'تحدي الذكاء الاصطناعي',
    setupTeamsTitle: 'تحدي فريقين',
    playerName: 'اسم اللاعب',
    playerPlaceholder: 'أدخل اسمك',
    teamOne: 'الفريق الأول',
    teamOnePlaceholder: 'أدخل اسم الفريق الأول',
    aiTeamLabel: 'الذكاء الاصطناعي',
    teamTwo: 'الفريق الثاني',
    teamTwoPlaceholder: 'أدخل اسم الفريق الثاني',
    aiChallengeTitle: 'اختبر معلوماتك أمام خصم ذكي',
    aiChallengeCopy: 'الذكاء الاصطناعي يختار ويجيب تلقائياً، وأنت تحاول التغلب عليه.',
    versus: 'مقابل',
    suggestNames: 'اقتراح الأسماء',
    questionCount: 'عدد الأسئلة:',
    noRepeat: 'بدون تكرار أثناء اللعب',
    randomCategory: 'اختيار عشوائي للتصنيف والمستوى',
    questionDuration: 'مدة السؤال:',
    secondsUnit: 'ثانية',
    muteSound: 'كتم الصوت',
    soundEffects: 'المؤثرات الصوتية في الخلفية',
    openPlay: 'اللعب المكشوف',
    openPlayDesc: 'الاستعانة بأي مصدر معلومات (إنترنت، ذكاء اصطناعي،...) لابد من تحدي الوقت',
    openPlayTime: 'وقت اللعب المكشوف',
    secondsOption: (seconds) => `${seconds} ثواني`,
    changeChallenge: 'تغيير نوع التحدي',
    startContest: 'ابدأ المسابقة',
    missingNamesTitle: 'لابد من تسمية الفريقين',
    missingNamesDesc: 'يرجى إدخال اسم لكل فريق قبل بدء المسابقة، أو اضغط على "اقتراح الأسماء" لاختيار أسماء جاهزة.',
    footerMadeBy: 'تصميم وتطوير',
    footerName: 'شايع الشايع',
    pickCountdown: 'باقي لاختيار المربع',
    currentTurn: 'الدور الآن على:',
    aiThinking: 'لاعب ذكاء اصطناعي يفكر',
    aiPick: 'سأختار المربع رقم',
    winRules: '🎯 قواعد الفوز',
    ruleConnect: 'اربط مربعات فريقك من جهة إلى الجهة المقابلة.',
    ruleOrthogonal: 'الاتصال يحسب للأعلى والأسفل واليمين واليسار فقط.',
    ruleCorners: 'الزوايا تحسب ضمن الجهات التي تلامسها، ولا يوجد اتصال قطري.',
    ruleTimeout: 'إذا لم تختار مربعًا خلال 30 ثانية تخسر دورك.',
    scoringModeTitle: 'تم قطع المسارات',
    scoringModeMessage: 'تم قطع المسارات على الفريقين. من الآن سيتم اللعب على عدد المربعات التي يكسبها كل فريق.',
    scoringModeBadge: 'وضع عد المربعات',
    scoringModeHelp: 'عند اكتمال اللوحة يفوز الفريق صاحب المربعات الأكثر.',
    finalScore: 'النتيجة النهائية',
    drawTitle: 'تعادل',
    drawName: 'تعادل الفريقان',
    drawSubtitle: 'اكتملت اللوحة بعدد مربعات متساو.',
    optionLabels: ['أ', 'ب', 'ج', 'د'],
    point: '+ نقطة',
    correctTitle: 'أحسنت!',
    wrongTitle: 'حظاً وافراً',
    correctSub: 'إجابة صحيحة - المربع لك',
    wrongSub: 'إجابة غير صحيحة - الدور ينتقل',
    questionFor: 'سؤال لـ:',
    level: 'المستوى:',
    winnerTitle: 'بطل مسابقة جسر المعرفة',
    playAgain: '🔄 العب مرة أخرى',
    aiTaunts: [
      'تتحداني يا بطل؟',
      'سأجعلها جولة ممتعة.',
      'هل أنت سريع البديهة بما يكفي؟',
      'أفكر بسرعة... لكن القرار يحتاج دقة.',
      'إجابة واحدة قد تغير مجرى اللعبة.',
      'هل حسبت خطوتك جيداً؟',
      'أبحث عن أفضل طريق للفوز.',
      'لا تتوقع أن يكون اختياري عشوائياً دائماً.',
      'دورك القادم قد يكون حاسماً.',
      'هل أنت مستعد لاختبار معلوماتك؟',
      'المعرفة القوية تصنع الفارق.',
      'لنرَ ماذا ستختار الآن.',
      'انتبه، الجولة بدأت تشتعل.',
      'هذا المربع يبدو مهماً.',
      'كل إجابة تقرّب أحدنا من الفوز.',
      'السرعة وحدها لا تكفي.',
      'ركز، فالقرار هنا مهم.',
      'أرى مساراً جيداً... هل تراه أنت؟',
      'لن أعتمد على الحظ فقط.',
      'استعد، فالجولة تحتاج ذكاء.',
      'أحسب الاحتمالات قبل اختياري.',
      'هذا الدور يحتاج قراراً دقيقاً.',
      'كل مربع قد يصنع فرقاً في النتيجة.',
      'سأترك لك فرصة صغيرة... ربما.',
      'اللوحة بدأت تكشف أسرارها.',
      'اختياري القادم قد يفاجئك.',
      'أتابع مسارك وأبني خطتي.',
      'خطوة واحدة قد تقلب النتيجة.',
      'هل تعتمد على معرفتك أم على حظك؟',
      'لن أجعل الطريق سهلاً اليوم.'
    ]
  },
  en: {
    dir: 'ltr',
    brandName: 'Knowledge Bridge',
    tagline: 'A trivia challenge between competitors',
    teamAiName: 'AI Player',
    loadingContent: 'Loading content',
    chooseChallenge: 'Choose Challenge Type',
    challengeTeams: 'Team Challenge',
    challengeTeamsSubtitle: 'Two teams on one device',
    challengeTeamsDesc: 'Take turns choosing squares and answering questions.',
    challengeAi: 'AI Challenge',
    challengeAiSubtitle: 'Play against a smart opponent',
    challengeAiDesc: 'Test your knowledge against an opponent that does not pick randomly.',
    challengeRemote: 'Remote Challenge',
    challengeRemoteSubtitle: 'Each team on its own device',
    challengeRemoteDesc: 'Play with friends wherever they are.',
    chooseChallengeAction: 'Choose challenge',
    gameSettings: '⚙️ Game Settings',
    chooseQuestionType: 'Choose Question Type',
    languageTitle: 'Interface Language',
    languageDesc: 'Switch between Arabic and English',
    questionBanks: {
      'general-ar': {
        title: 'General — Arabic',
        countText: '1200 Questions',
        description: 'Arabic questions suitable for adults and families',
        languageLabel: 'Arabic'
      },
      'general-en': {
        title: 'General — English',
        countText: '500 Questions',
        description: 'English questions suitable for adults and families',
        languageLabel: 'English'
      },
      'kids-ar': {
        title: 'Kids — Arabic',
        countText: '300 Questions',
        description: 'Smart and fun Arabic questions for kids ages 8 to 11',
        languageLabel: 'Arabic'
      },
      'kids-en': {
        title: 'Kids — English',
        countText: '300 Questions',
        description: 'Smart and fun questions for kids ages 8 to 11',
        languageLabel: 'English'
      }
    },
    remoteTitle: 'Remote Challenge',
    remoteDesc: 'This challenge will be available in the mobile version. Use the Knowledge Bridge mobile app to play with friends on separate devices.',
    comingSoon: 'Coming soon',
    ok: 'OK',
    setupAiTitle: 'AI Challenge',
    setupTeamsTitle: 'Team Challenge',
    playerName: 'Player Name',
    playerPlaceholder: 'Enter your name',
    teamOne: 'Team One',
    teamOnePlaceholder: 'Enter team one name',
    aiTeamLabel: 'Artificial Intelligence',
    teamTwo: 'Team Two',
    teamTwoPlaceholder: 'Enter team two name',
    aiChallengeTitle: 'Test your knowledge against a smart opponent',
    aiChallengeCopy: 'The AI chooses and answers automatically while you try to beat it.',
    versus: 'VS',
    suggestNames: 'Suggest names',
    questionCount: 'Questions:',
    noRepeat: 'No repeats during play',
    randomCategory: 'Random category and difficulty',
    questionDuration: 'Question time:',
    secondsUnit: 'seconds',
    muteSound: 'Mute Sound',
    soundEffects: 'Background sound effects',
    openPlay: 'Open Play',
    openPlayDesc: 'Use any information source, but beat the clock.',
    openPlayTime: 'Open Play Time',
    secondsOption: (seconds) => `${seconds} sec`,
    changeChallenge: 'Change Challenge Type',
    startContest: 'Start Contest',
    missingNamesTitle: 'Team names are required',
    missingNamesDesc: 'Please enter a name for each team before starting, or use suggested names.',
    footerMadeBy: 'Design and development',
    footerName: 'Shaye Alshaye',
    pickCountdown: 'Time left to pick a square',
    currentTurn: 'Current turn:',
    aiThinking: 'AI player is thinking',
    aiPick: 'I will choose square',
    winRules: '🎯 Winning Rules',
    ruleConnect: 'Connect your team squares from one side to the opposite side.',
    ruleOrthogonal: 'Connections count only up, down, left, and right.',
    ruleCorners: 'Corners count through touching sides, with no diagonal connection.',
    ruleTimeout: 'If you do not choose a square within 30 seconds, you lose your turn.',
    scoringModeTitle: 'Paths blocked',
    scoringModeMessage: 'Both teams have blocked each other paths. From now on, the winner will be decided by the number of claimed squares.',
    scoringModeBadge: 'Square count mode',
    scoringModeHelp: 'When the board is full, the team with more squares wins.',
    finalScore: 'Final score',
    drawTitle: 'Draw',
    drawName: 'Both teams tied',
    drawSubtitle: 'The board is full with an equal number of squares.',
    optionLabels: ['A', 'B', 'C', 'D'],
    point: '+ Point',
    correctTitle: 'Nice!',
    wrongTitle: 'Good Try',
    correctSub: 'Correct answer - the square is yours',
    wrongSub: 'Incorrect answer - the turn moves on',
    questionFor: 'Question for:',
    level: 'Level:',
    winnerTitle: 'Knowledge Bridge Champion',
    playAgain: '🔄 Play Again',
    aiTaunts: [
      'Think you can outsmart me?',
      "I'll make this round exciting.",
      'Are you quick enough?',
      'Thinking fast... but choosing carefully.',
      'One answer can change the whole game.',
      'Did you plan that move carefully?',
      'I am looking for the best path to victory.',
      "Don't expect my choices to be random every time.",
      'Your next turn could be important.',
      'Are you ready to test your knowledge?',
      'Strong knowledge can make the difference.',
      "Let's see what you choose now.",
      'Stay sharp, this round is heating up.',
      'This square looks important.',
      'Every answer brings one of us closer to winning.',
      'Speed alone is not enough.',
      'Focus, this decision matters.',
      'I see a good path. Do you?',
      "I won't rely on luck alone.",
      'Get ready, this round needs smart thinking.',
      'I calculate the odds before I choose.',
      'This turn needs a precise decision.',
      'Every square can make a difference.',
      'I may give you a small chance. Maybe.',
      'The board is starting to reveal its secrets.',
      'My next choice might surprise you.',
      'I am following your path and building my plan.',
      'One move can change the result.',
      'Are you counting on knowledge or luck?',
      "I won't make the path too easy today."
    ]
  }
};

export function getText(language) {
  return UI_TEXT[language] || UI_TEXT.ar;
}
